import { render, staticRenderFns } from "./spaceinfo.vue?vue&type=template&id=1c0ed382&scoped=true&"
import script from "./spaceinfo.vue?vue&type=script&lang=js&"
export * from "./spaceinfo.vue?vue&type=script&lang=js&"
import style0 from "./spaceinfo.vue?vue&type=style&index=0&id=1c0ed382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ed382",
  null
  
)

component.options.__file = "spaceinfo.vue"
export default component.exports